import React from 'react';

const WeStand = () => {
  return (
    <section className="we-stand" id="membership">
      <div className="container">
        <div className="we-stand__top">
          <div className="we-stand__top-title-box">
            <div className="we-stand__top-title-box-bg"></div>
            <h2 style={{ backgroundImage: "url(https://images.pexels.com/photos/6192464/pexels-photo-6192464.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)", backgroundSize: "cover", backgroundPosition: "top", backgroundRepeat: "no-repeat", backgroundAttachment: "fixed" }} className="we-stand__top-title">CREATIVITY</h2>
          </div>
          <div className="we-stand-shape">
            <img src="assets/images/shapes/we-stand-shape.png" alt="decorative shape" />
          </div>
        </div>
        <div className="we-stand__bottom">
          <div className="row">
            <div className="col-xl-4 col-lg-4">
              <div className="we-stand__left">
                <div className="section-title text-left">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">Membership Levels</span>
                    <div className="section-title-shape">
                      <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
                    </div>
                  </div>
                  <h2 className="section-title__title">Join Our Community</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-8">
              <div className="we-stand__text-box">
                <div className="we-stand__progress">
                  <div className="we-stand__progress-single">
                    <h4 className="we-stand__progress-title">General Members</h4>
                    <p>Access content, join discussions, and attend events.</p>
                  </div>
                  <div className="we-stand__progress-single">
                    <h4 className="we-stand__progress-title">Active Creatives</h4>
                    <p>Contribute to community projects and are eligible for mentorship.</p>
                  </div>
                  <div className="we-stand__progress-single">
                    <h4 className="we-stand__progress-title">Core Contributors</h4>
                    <p>Hold roles, lead units, and host workshops.</p>
                  </div>
                  <div className="we-stand__progress-single">
                    <h4 className="we-stand__progress-title">Mentors/Advisors</h4>
                    <p>Professionals volunteering their time and guidance.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WeStand;
